var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"cc-plain-text",class:`text-font-${_vm.fontName}`,style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.content.content || '请添加文本内容')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }